export enum LocalStorageKeys {
  CURRENT_TASK = 'task.current-task',
  CURRENT_REPORT = 'report.current-report',
}
